import { Form, Button } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import DisplayUDF from "features/clients/details/userDefinedFields/displayUdf";
import UDF from "redux/models/udf";

import {
  generateUdfSetFieldValues,
  generateUdfValuesObject,
} from "utilities/generalUtility";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateCandidateUdf } from "../../../redux/slices/udfSlice";

export default function UDFEditComponent({
  candidateJobEntryId,
  item,
  onCancel,
}) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    const udfValues = generateUdfSetFieldValues([item]);
    form.setFieldsValue(udfValues);
  }, []);

  const onFinish = async (values) => {
    try {
      let value = null;
      const generatedValues = generateUdfValuesObject([item], values);
      if (item.udfMultiValueFieldTypeVal.length > 0) {
        value = generatedValues.length > 0 ? generatedValues[0].optionIds : [];
      } else {
        value = generatedValues.length > 0 ? generatedValues[0].value : "";
      }

      const payload = {
        candidateJobEntryId,
        multiValues: item.udfMultiValueFieldTypeVal.length > 0,
        value,
        userDefinedFieldId: Object.keys(values).at(0),
      };

      const res = await UDF.editUdfFieldsValue(payload);

      if (res) {
        dispatch(updateCandidateUdf(res));
      }

      onCancel();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Form
      layout="vertical"
      initialValues={{ interviewConfirmation: false }}
      className="display-udf-form"
      onFinish={onFinish}
      form={form}
    >
      <>
        <DisplayUDF
          isFormItem
          title={item.label}
          form={form}
          fieldTypeId={item.fieldTypeId}
          udfId={item.id}
          isRequired={item.isRequired}
          formItemName={item.label}
          options={
            item.udfMultiValueFieldTypeVal.length
              ? item.udfMultiValueFieldTypeVal
              : []
          }
        />

        <Button
          type="link"
          onClick={onCancel}
          icon={<CloseCircleOutlined className="closeIcon" />}
        />
        <Button
          type="link"
          onClick={() => form.submit()}
          icon={<CheckCircleOutlined className="checkIcon" />}
        />
      </>
    </Form>
  );
}
